import { render, staticRenderFns, recyclableRender, components } from "./vip-rich-page.vue?vue&type=template&id=292cddfb&scoped=true&"
var renderjs
import script from "./vip-rich-page.vue?vue&type=script&lang=js&"
export * from "./vip-rich-page.vue?vue&type=script&lang=js&"
import style0 from "./vip-rich-page.vue?vue&type=style&index=0&id=292cddfb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292cddfb",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/vip-rich-page.vue"
export default component.exports